<h2 mat-dialog-title>{{ data.title }}</h2>
<p>{{ data.description }}</p>
<ul>
  Please note:
  <li>No submission content or review commentary is changed.</li>
  <li>
    The Specialist Review recommendation will be cleared if already in place and reverting to a state prior to the
    recommendation being submitted.
  </li>
  <li>
    PM Support will be cleared if already in place and reverting to a state prior to PM Appraisal.
  </li>
  <li>
    Provisional Agreement will be cleared if already in place and reverting to a state prior to submission in
    preparation.
  </li>
</ul>
<p class="warning" *ngIf="hasWarning()">{{ data.warning }}</p>

<mat-dialog-content>
  <mat-form-field>
    <mat-select [formControl]="revertStateControl" [required]="true" placeholder="Revert state">
      <mat-option *ngFor="let option of previousStateOptions" [value]="option.workflowState">
        <span>{{ option.displayName }}</span>
      </mat-option>
    </mat-select>
    <mat-error>
      A state to revert to must be provided
    </mat-error>
  </mat-form-field>

  <mat-form-field class="input">
    <textarea
      cdkTextareaAutosize
      #autosize="cdkTextareaAutosize"
      matInput
      type="text"
      placeholder="Add a comment"
      [formControl]="inputComment"
      [required]="data.commentRequired"
    >
    </textarea>
    <mat-error>
      {{ errorText() }}
    </mat-error>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button color="primary" (click)="cancel()">CANCEL</button>
  <button mat-raised-button color="warn" (click)="confirmAndClose()" [disabled]="!formIsValid()">REVERT</button>
</mat-dialog-actions>
